import log from "loglevel";
export class VideoTailLooper {
    constructor({ video, from, to, }) {
        this.video = video;
        this.onTimeUpdate = this.onTimeUpdate.bind(this);
        this.onEnded = this.onEnded.bind(this);
        this.from = from;
        this.to = to;
    }
    run() {
        this.video.addEventListener("timeupdate", this.onTimeUpdate);
        this.video.addEventListener("ended", this.onEnded);
    }
    onTimeUpdate() {
        if (this.video.currentTime >= this.to) {
            log.debug("loop by time update");
            this.video.currentTime = this.from;
            this.video.play();
        }
        else if (this.video.duration === this.video.currentTime) {
            log.debug("loop by video end in onTimeUpdate");
            this.video.currentTime = this.from;
            this.video.play();
        }
    }
    onEnded() {
        log.debug("loop by video end in onEnded");
        this.video.currentTime = this.from;
        this.video.play();
    }
    dispose() {
        this.video.removeEventListener("timeupdate", this.onTimeUpdate);
        this.video.removeEventListener("ended", this.onEnded);
    }
}
//# sourceMappingURL=videoTailLooper.js.map